var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',{class:'asset-modal lti-preview-modal',attrs:{"title":_vm.asset.title,"active":_vm.popupActive},on:{"update:active":function($event){_vm.popupActive=$event}}},[_c('LtiContent',{attrs:{"asset":_vm.asset}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }